(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initReveal = (root) => {
    const items = root.querySelectorAll('.pk9n-reveal:not(.is-visible)');
    if (reduced || !('IntersectionObserver' in window)) { items.forEach((item) => item.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });
    items.forEach((item) => observer.observe(item));
  };
  const initProgress = (root) => {
    const bar = root.querySelector('.pk9n-progress span');
    if (!bar) return;
    const update = () => {
      const rect = root.getBoundingClientRect();
      const total = Math.max(root.offsetHeight - window.innerHeight, 1);
      bar.style.transform = `scaleX(${Math.min(Math.max(-rect.top, 0), total) / total})`;
    };
    update(); window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update, { passive: true });
  };
  const initRail = (rail) => {
    const DRAG_THRESHOLD = 8;
    let pressed = false, dragging = false, startX = 0, startScroll = 0, pointerId = null, suppressNextClick = false;
    const finish = () => {
      if (!pressed && !dragging) return;
      const wasDragging = dragging;
      pressed = false; dragging = false; rail.classList.remove('dragging');
      if (pointerId !== null && rail.hasPointerCapture?.(pointerId)) rail.releasePointerCapture?.(pointerId);
      pointerId = null;
      if (wasDragging) { suppressNextClick = true; window.setTimeout(() => { suppressNextClick = false; }, 250); }
    };
    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      pressed = true; dragging = false; pointerId = event.pointerId; startX = event.clientX; startScroll = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', (event) => {
      if (!pressed || event.pointerId !== pointerId) return;
      const deltaX = event.clientX - startX;
      if (!dragging) { if (Math.abs(deltaX) < DRAG_THRESHOLD) return; dragging = true; rail.classList.add('dragging'); rail.setPointerCapture?.(event.pointerId); }
      event.preventDefault(); rail.scrollLeft = startScroll - deltaX;
    });
    rail.addEventListener('pointerup', finish); rail.addEventListener('pointercancel', finish);
    rail.addEventListener('mouseleave', () => { if (dragging) finish(); });
    rail.addEventListener('click', (event) => { if (!suppressNextClick) return; event.preventDefault(); event.stopPropagation(); suppressNextClick = false; }, true);
  };
  const init = (root) => {
    if (!root || root.dataset.pk9Ready === 'true') return;
    root.querySelector('.pk9n-hero__wardrobe')?.remove();
    initReveal(root); initProgress(root);
    root.querySelectorAll('.pk9n-tier__saving').forEach((item) => { item.textContent = 'sur toute la boutique'; });
    root.querySelectorAll('[data-pk9-rail]').forEach(initRail);
    root.dataset.pk9Ready = 'true';
  };
  const boot = () => document.querySelectorAll('[data-pk9-signature]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-pk9-signature]')));
})();

(() => {
  const PRODUCTS = [
    { title: 'PK9 QUIET CROWN — Casquette Hors-Série', type: 'Casquette', handle: 'template32', image: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/files/store-1788006829752-9008759967.png?v=1788006835', price: 39 },
    { title: 'PK9 BLACK LABEL — Tee Hors-Série', type: 'T-shirt', handle: 'pk9-black-label-tee-hors-serie', image: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/files/ChatGPTImage29aout2026_16_44_17_7.png?v=1788014702', price: 59 },
    { title: 'RIVER//99 — READ THE UNREADABLE', type: 'Hoodie', handle: 'unisex-oversized-hoodie', image: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/files/ChatGPTImage28aout2026_17_23_56_14.png?v=1787930654', price: 139 },
    { title: 'PRIVATE TABLE 09: Observe More', type: 'Hoodie', handle: 'private-table-09', image: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/files/private-table-09-mockup-02-femme-face_6c00c30a-481b-49ca-82ed-5d059501e776.png?v=1787584263', price: 169 }
  ];
  const formatMoney = (amount) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  const cardMarkup = (product) => `<article class="pk9n-product pk9n-reveal is-visible"><a href="/products/${product.handle}"><div><img src="${product.image}" loading="lazy" alt="${product.title}" width="900" height="1100"><em>HORS SÉRIE</em></div><footer><span><small>${product.type}</small><b>${product.title}</b></span><strong>${formatMoney(product.price)}</strong></footer></a></article>`;
  const createSection = (root) => {
    if (!root || root.querySelector('#pk9-best-sellers')) return;
    const hero = root.querySelector('.pk9n-hero'); if (!hero) return;
    const section = document.createElement('section');
    section.id = 'pk9-best-sellers'; section.className = 'pk9n-selection pad pk9n-best-sellers';
    section.innerHTML = `<header class="pk9n-head pk9n-reveal is-visible"><div><p class="pk9n-kicker">HORS SÉRIE</p><h2>Les Hors-Série PK9.</h2></div><div><p>Quatre pièces confidentielles, produites en séries limitées et pensées pour ceux qui jouent autrement.</p><a class="pk9n-link" href="/collections/hors-serie">Voir toute la collection →</a></div></header><div class="pk9n-products">${PRODUCTS.map(cardMarkup).join('')}</div>`;
    hero.insertAdjacentElement('afterend', section);
  };
  const bootBestSellers = () => document.querySelectorAll('[data-pk9-signature]').forEach(createSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootBestSellers, { once: true }); else bootBestSellers();
  document.addEventListener('shopify:section:load', (event) => { const root = event.target.querySelector('[data-pk9-signature]'); if (root) createSection(root); });
})();

(() => {
  const releaseAt = new Date('2026-09-01T00:00:00+02:00').getTime();
  const universeNames = ['Deluxe', 'Essential', 'Future Division', 'Grindeuse'];
  const style = document.createElement('style');
  style.id = 'pk9-launch-lock-style';
  style.textContent = `
    .pk9n-universe.pk9-launch-locked { cursor: default; }
    .pk9n-universe.pk9-launch-locked > div img { filter: brightness(.28) saturate(.25) blur(3px) !important; transform: scale(1.04); }
    .pk9n-universe.pk9-launch-locked > i { z-index: 3; background: rgba(4, 7, 12, .68); backdrop-filter: blur(3px); }
    .pk9-launch-lock { position:absolute; z-index:4; inset:0; display:grid; place-items:center; padding:1.25rem; text-align:center; color:#fff; pointer-events:none; }
    .pk9-launch-lock__inner { width:min(290px, 88%); padding:1.35rem 1rem; border:1px solid rgba(213,173,98,.75); background:rgba(8,11,17,.7); box-shadow:0 14px 40px rgba(0,0,0,.26); }
    .pk9-launch-lock small { display:block; color:#d5ad62; font-size:.61rem; font-weight:800; letter-spacing:.17em; text-transform:uppercase; }
    .pk9-launch-lock strong { display:block; margin:.5rem 0 .35rem; font-family:Didot, 'Bodoni MT', Georgia, serif; font-size:clamp(1.7rem,3vw,2.55rem); font-weight:400; letter-spacing:-.04em; }
    .pk9-launch-lock time { display:block; color:rgba(255,255,255,.82); font-size:.69rem; font-weight:800; letter-spacing:.1em; }
  `;
  const addStyle = () => { if (!document.getElementById(style.id)) document.head.appendChild(style); };
  const renderRemaining = (milliseconds) => {
    const seconds = Math.max(0, Math.floor(milliseconds / 1000));
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${days}j ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(secs).padStart(2, '0')}s`;
  };
  const removeRetiredSections = (root) => {
    const testers = root?.querySelector('.pk9n-testers');
    const grindeuseSelection = testers?.nextElementSibling;
    if (testers) testers.remove();
    if (grindeuseSelection?.classList.contains('pk9n-selection')) grindeuseSelection.remove();
  };
  const lockUniverses = (root) => {
    if (!root) return;
    const now = Date.now();
    const cards = [...root.querySelectorAll('.pk9n-universe')];
    if (now >= releaseAt) {
      cards.forEach((card) => { if (card.dataset.pk9OriginalHref) card.href = card.dataset.pk9OriginalHref; card.classList.remove('pk9-launch-locked'); card.querySelector('.pk9-launch-lock')?.remove(); card.removeAttribute('aria-disabled'); });
      return;
    }
    cards.forEach((card, index) => {
      if (!card.dataset.pk9OriginalHref) card.dataset.pk9OriginalHref = card.getAttribute('href') || '';
      card.removeAttribute('href'); card.setAttribute('aria-disabled', 'true'); card.classList.add('pk9-launch-locked');
      if (!card.querySelector('.pk9-launch-lock')) {
        const overlay = document.createElement('div');
        overlay.className = 'pk9-launch-lock';
        overlay.innerHTML = `<div class="pk9-launch-lock__inner"><small>${universeNames[index] || 'NOUVEL UNIVERS'}</small><strong>Ouverture le 1er septembre</strong><time aria-live="polite"></time></div>`;
        card.appendChild(overlay);
      }
    });
    root.querySelectorAll('.pk9-launch-lock time').forEach((time) => { time.textContent = renderRemaining(releaseAt - now); });
  };
  const applyLaunchState = () => {
    addStyle();
    document.querySelectorAll('[data-pk9-signature]').forEach((root) => { removeRetiredSections(root); lockUniverses(root); });
  };
  const bootLaunch = () => {
    applyLaunchState();
    window.setInterval(applyLaunchState, 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootLaunch, { once: true }); else bootLaunch();
  document.addEventListener('shopify:section:load', bootLaunch);
})();
